import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { Box, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { ASPECT_RATIO } from 'components/UploadImage'
import { FONT_SIZE } from 'Theme'

export const ProductLink = ({
  productImageUrl,
  productImageAlt,
  title,
  options,
  href,
}: {
  productImageUrl: string
  productImageAlt: string
  title: string
  options?: string[]
  href: string
}) => (
  <Link href={href} passHref>
    <Flex gap="14px" alignItems="center" mt="28px">
      <Box width="56px" height="56px" borderRadius="10px" overflow="hidden">
        <Image
          alt={productImageAlt || title}
          objectFit="cover"
          style={{
            aspectRatio: ASPECT_RATIO.PRODUCTS,
            width: '100%',
          }}
          src={productImageUrl}
          sizes="100vw"
          width="0"
          height="0"
        />
      </Box>
      <Box>
        <Text color="black" fontSize={FONT_SIZE.PX_13} as="p">
          {title}
        </Text>
        {options &&
          options.length > 0 &&
          options.map((option) => (
            <Text color="black" fontSize={FONT_SIZE.PX_11} as="p" key={option}>
              {option}
            </Text>
          ))}
      </Box>
    </Flex>
  </Link>
)
